
import * as defaultImport from "lodash/isEqual";
export * from "lodash/isEqual";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
